import { render } from "./CommandCentersConfigurationComponent.vue?vue&type=template&id=50ae1d10"
import script from "./CommandCentersConfigurationComponent.vue?vue&type=script&lang=js"
export * from "./CommandCentersConfigurationComponent.vue?vue&type=script&lang=js"

import "./CommandCentersConfigurationComponent.vue?vue&type=style&index=0&id=50ae1d10&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__